export default __webpack_public_path__ + "static/call-me-maybe-4260a7db5b50bfee2d3778a41aac61dc.jpg";